import campaignActionSharedMutations from '@/campaign-action-shared/store/mutations'

export default {
  ...campaignActionSharedMutations,

  categoriesModalClosed(state) {
    state.categoriesModalOpen = false
  },

  hideShareBanner(state) {
    state.showingShareBanner = false
  },

  imageUploadModalClosed(state) {
    state.imageUploadModalOpen = false
  },

  openCategoriesModal(state) {
    state.categoriesModalOpen = true
  },

  openImageUploadModal(state) {
    state.imageUploadModalOpen = true
  },

  setAlreadySigned(state, { actionTakerName, createPetitionCommentPath}) {
    state.signed = true
    state.alreadySignedOnPageLoad = true
    state.actionTakerName = actionTakerName
    state.createPetitionCommentPath = createPetitionCommentPath
  },

  setCategoryIds(state, categoryIds) {
    state.petition.categoryIds = categoryIds
  },

  setHasImage(state, hasImage) {
    state.petition.hasImage = hasImage
  },

  setShareButtonClicked(state) {
    state.shareButtonClicked = true
  },

  showShareBanner(state) {
    state.showingShareBanner = true
  }
}
